import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import type { TOC } from '@ember/component/template-only';
import BvInline from 'volta/components/bv-inline';
import BvText from 'volta/components/bv-text';
import BvTag from 'volta/components/bv-tag';
import { t } from 'ember-intl';
interface CreateOptionSignature {
    Args: {
        term?: string;
    };
    Element: HTMLDivElement;
}
const CreateOption: TOC<CreateOptionSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <BvInline @gap='2' @blockAlign='center'>
    <BvText @text={{t 'add'}} />
    <BvTag @size='sm' @color='primary' @text={{@term}} />
  </BvInline>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default CreateOption;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        'BvSelectCreate::CreateOption': typeof CreateOption;
        'bv-select-create/create-option': typeof CreateOption;
    }
}
